<template>
  <section v-editable="cms" :class="[name]" :style="mainCssVars">
    <div :class="`${name}__practices`">
      <component
        :is="item.component"
        v-for="(item, index) in cms.collection"
        :key="index"
        v-editable="item"
        :cms="item"
        :class="`${name}__practice`"
      />
    </div>
  </section>
</template>
<script>
import data from '@/components/organisms/o-list-practices/o-list-practices-v2.data'
import MCardPractice from '@/components/molecules/m-cards/m-card-practice'
import Colors from '~/mixins/colors'

export default {
  components: {
    MCardPractice,
  },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-practices',
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#FFFFFF'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--filter': this.cms.filter || null,
        '--bg-color-logo': this.setColor(
          (this.cms.logo_background_color || {}).color || '',
          this.cms.color_gradient
        ),
        '--text-color-logo': this.setColor(
          (this.cms.logo_color_text || {}).color || '#000000'
        ),
        '--hover-color-logo': this.setColor(
          (this.cms.logo_color_text_hover || {}).color || ''
        ),
        '--hover-bg-color-logo': this.setColor(
          (this.cms.logo_background_color_hover || {}).color || ''
        ),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-practices {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: transparent;
  border-color: var(--text-color);
  color: var(--text-color);

  ::v-deep img {
    filter: var(--filter);
  }

  &__practices {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 6px;
  }
  &__practice {
    ::v-deep img {
      transition: background-color 0.2s ease-in-out, filter 0.2s ease-in-out;
      &:hover {
        filter: invert(1);
        background: var(--bg-color);
      }
    }
  }
}

@include media-breakpoint-up(md) {
  .m-practices {
    &__practices {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 10px;
    }
  }
}

@include media-breakpoint-up(lg) {
  .m-practices {
    &__practices {
      grid-template-columns: repeat(6, 1fr);
    }
  }
}
</style>
